<template>
    <div>
        <div class="flex justify-center w-full">
            <custom-tooltip bottom border>
                <app-button icon circle @click="openNewFilter">
                    <img
                        src="@/assets/images/filter.svg"
                        height="15"
                        width="15"
                        alt="reload img"
                    />
                </app-button>

                <template #tooltip> Modificar filtros de búsqueda </template>
            </custom-tooltip>
        </div>

        <div class="flex flex-col mt-1">
            <div
                v-if="activeFilters.includes('line')"
                class="md:w-6/12 w-8/12 mx-auto mb-4"
            >
                <subline-selector
                    v-model="line"
                    add-root
                    :default-filters="{}"
                    enabled
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('keyword')"
                class="md:w-6/12 w-8/12 mx-auto mb-4"
            >
                <custom-input
                    v-model="keyword"
                    type="text"
                    placeholder="Buscar por palabra clave .."
                    class="mr-2"
                    @blur="applyFilter"
                    @enter="onEnter"
                >
                    <template #icon> 🔎 </template>
                </custom-input>
            </div>
        </div>

        <app-dialog v-model="isOpenModal" size="lg" @close="pushNewFilter">
            <template #header>
                <div class="flex items-center justify-between gap-4">
                    <h3 class="text-base font-semibold text-theme-base">
                        Selecciona los filtros
                    </h3>

                    <app-button
                        :disabled="!filters.length"
                        @click="isOpenModal = false"
                    >
                        ✔️ Aplicar filtros ({{ filters.length }})
                    </app-button>
                </div>
            </template>
            <cards-selector v-model="filters" :base="baseFilters" />
        </app-dialog>
    </div>
</template>

<script>
import { bannersFilters } from "@/common/fields/filters-query";

import AppDialog from "@/components/utils/AppDialog.vue";
import CardsSelector from "@/components/utils/CardsSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "BannersFilters",
    components: {
        AppDialog,
        CardsSelector,
        CustomInput,
        SublineSelector: () => import("@/components/lines/SublineSelector.vue")
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            default: () => ({}),
            type: Object,
            require: true
        },
        enabledFilters: {
            default: () => ["line", "keyword"],
            type: Array,
            require: true
        }
    },
    emits: ["change", "enter"],
    data: () => ({
        activeFilters: [],
        isOpenModal: false,
        keyword: "",
        line: { slug: "otros", name: "Otros" },
        filters: [],
        baseFilters: bannersFilters
    }),
    watch: {
        enabledFilters(value) {
            this.setEnabledFilters(value);
        }
    },
    mounted() {
        this.setEnabledFilters(this.enabledFilters);
        this.setInput(this.itemsCurrent);
    },
    methods: {
        setInput(value) {
            const filters = Object.keys(value);
            this.activeFilters = filters;
            this.filters = filters;
            if ("keyword" in value) this.keyword = value.keyword;
            if ("lineSlug" in value) {
                this.line = { slug: value.lineSlug, name: value.lineSlug };
            }
        },
        openNewFilter() {
            this.isOpenModal = true;
        },
        pushNewFilter() {
            this.activeFilters = [...this.filters];
            this.applyFilter();
        },
        applyFilter() {
            this.$emit("change", {
                ...{
                    ...(this.activeFilters.includes("line")
                        ? { lineSlug: this.line.slug }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("keyword")
                        ? { keyword: this.keyword }
                        : null)
                }
            });
        },
        onEnter() {
            this.applyFilter();
            this.$emit("enter");
        },
        setEnabledFilters(value) {
            this.baseFilters = bannersFilters.filter((item) => {
                const hasPermission =
                    !item.permissions ||
                    item.permissions.every((permission) =>
                        this.$ability.hasPermission(permission)
                    );
                return value.includes(item.id) && hasPermission;
            });
        }
    }
};
</script>
